"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.AttributeDropdown = void 0;
var tslib_1 = require("tslib");
// (C) 2022 GoodData Corporation
var react_1 = tslib_1.__importStar(require("react"));
var sdk_model_1 = require("@gooddata/sdk-model");
var types_1 = require("../types");
var Dropdown_1 = require("../../Dropdown");
var List_1 = require("../../List");
var MeasureDropdown_1 = require("../MeasureDropdown/MeasureDropdown");
var icons = (_a = {},
    _a[types_1.SORT_TARGET_TYPE.ALPHABETICAL_ASC] = "gd-icon-sort-alphabetical-asc",
    _a[types_1.SORT_TARGET_TYPE.ALPHABETICAL_DESC] = "gd-icon-sort-alphabetical-desc",
    _a[types_1.SORT_TARGET_TYPE.DATE_ASC] = "gd-icon-sort-date-asc",
    _a[types_1.SORT_TARGET_TYPE.DATE_DESC] = "gd-icon-sort-date-desc",
    _a[types_1.SORT_TARGET_TYPE.DEFAULT] = "gd-icon-sort-default",
    _a[types_1.SORT_TARGET_TYPE.NUMERICAL_ASC] = "gd-icon-sort-numerical-asc",
    _a[types_1.SORT_TARGET_TYPE.NUMERICAL_DESC] = "gd-icon-sort-numerical-desc",
    _a);
var getIconClassName = function (sortType) { return icons[sortType]; };
var getSortTypeItems = function (available, bucketItems, intl) {
    var _a;
    var sortTypeItems = [];
    var bucketItem = bucketItems[available.itemId.localIdentifier];
    if (available.attributeSort.normalSortEnabled && bucketItem.type === "attribute") {
        sortTypeItems.push({
            id: types_1.SORT_TARGET_TYPE.ALPHABETICAL_ASC,
            title: intl.formatMessage({ id: "sorting.type.alphabetical.asc" }),
            sortDirection: "asc",
            type: "alphabetical",
            localIdentifier: available.itemId.localIdentifier,
        }, {
            id: types_1.SORT_TARGET_TYPE.ALPHABETICAL_DESC,
            title: intl.formatMessage({ id: "sorting.type.alphabetical.desc" }),
            sortDirection: "desc",
            type: "alphabetical",
            localIdentifier: available.itemId.localIdentifier,
        });
    }
    if (available.attributeSort.normalSortEnabled && bucketItem.type === "chronologicalDate") {
        sortTypeItems.push({
            id: types_1.SORT_TARGET_TYPE.DATE_ASC,
            title: intl.formatMessage({ id: "sorting.type.date.asc" }),
            sortDirection: "asc",
            type: "date",
            localIdentifier: available.itemId.localIdentifier,
        }, {
            id: types_1.SORT_TARGET_TYPE.DATE_DESC,
            title: intl.formatMessage({ id: "sorting.type.date.desc" }),
            sortDirection: "desc",
            type: "date",
            localIdentifier: available.itemId.localIdentifier,
        });
    }
    if (available.attributeSort.areaSortEnabled || ((_a = available.metricSorts) === null || _a === void 0 ? void 0 : _a.length) > 0) {
        sortTypeItems.push({
            id: types_1.SORT_TARGET_TYPE.NUMERICAL_ASC,
            title: intl.formatMessage({ id: "sorting.type.numerical.asc" }),
            sortDirection: "asc",
            type: "numerical",
            localIdentifier: available.itemId.localIdentifier,
        }, {
            id: types_1.SORT_TARGET_TYPE.NUMERICAL_DESC,
            title: intl.formatMessage({ id: "sorting.type.numerical.desc" }),
            sortDirection: "desc",
            type: "numerical",
            localIdentifier: available.itemId.localIdentifier,
        });
    }
    if (available.attributeSort.normalSortEnabled && bucketItem.type === "genericDate") {
        sortTypeItems.push({
            id: types_1.SORT_TARGET_TYPE.DEFAULT,
            title: intl.formatMessage({ id: "sorting.type.default" }),
            sortDirection: "asc",
            type: "default",
            localIdentifier: available.itemId.localIdentifier,
        });
    }
    return sortTypeItems;
};
var getNumericSortTargetType = function (currentItem) {
    return sdk_model_1.sortDirection(currentItem) === "asc" ? types_1.SORT_TARGET_TYPE.NUMERICAL_ASC : types_1.SORT_TARGET_TYPE.NUMERICAL_DESC;
};
var getAlphabeticalSortTargetType = function (currentItem) {
    return sdk_model_1.sortDirection(currentItem) === "asc"
        ? types_1.SORT_TARGET_TYPE.ALPHABETICAL_ASC
        : types_1.SORT_TARGET_TYPE.ALPHABETICAL_DESC;
};
var getDateSortTargetType = function (currentItem) {
    return sdk_model_1.sortDirection(currentItem) === "asc" ? types_1.SORT_TARGET_TYPE.DATE_ASC : types_1.SORT_TARGET_TYPE.DATE_DESC;
};
var getSelectedItemId = function (currentItem, bucketItems) {
    if (sdk_model_1.isAttributeSort(currentItem)) {
        var bucketItem = bucketItems[currentItem.attributeSortItem.attributeIdentifier];
        if (sdk_model_1.isAttributeAreaSort(currentItem)) {
            return getNumericSortTargetType(currentItem);
        }
        if ((bucketItem === null || bucketItem === void 0 ? void 0 : bucketItem.type) === "chronologicalDate") {
            return getDateSortTargetType(currentItem);
        }
        if ((bucketItem === null || bucketItem === void 0 ? void 0 : bucketItem.type) === "genericDate") {
            return types_1.SORT_TARGET_TYPE.DEFAULT;
        }
        return getAlphabeticalSortTargetType(currentItem);
    }
    return getNumericSortTargetType(currentItem);
};
var getButtonValue = function (sortTypeItems, type) {
    var foundItem = sortTypeItems.find(function (sortTypeItems) { return sortTypeItems.id === type; });
    return foundItem ? foundItem.title : "";
};
var buildSortItem = function (_a, availableSorts) {
    var type = _a.type, localIdentifier = _a.localIdentifier, sortDirection = _a.sortDirection;
    if (type === "alphabetical" || type === "date" || type === "default") {
        return sdk_model_1.newAttributeSort(localIdentifier, sortDirection);
    }
    else if (availableSorts.attributeSort.areaSortEnabled) {
        return sdk_model_1.newAttributeAreaSort(localIdentifier, sortDirection);
    }
    else {
        var measureLocatorItem = availableSorts.metricSorts[0].locators.find(sdk_model_1.isMeasureLocator).measureLocatorItem;
        return sdk_model_1.newMeasureSort(measureLocatorItem.measureIdentifier, sortDirection);
    }
};
exports.AttributeDropdown = function (_a) {
    var currentSortItem = _a.currentSortItem, availableSorts = _a.availableSorts, bucketItems = _a.bucketItems, intl = _a.intl, index = _a.index, onSelect = _a.onSelect, enableRenamingMeasureToMetric = _a.enableRenamingMeasureToMetric;
    var _b = tslib_1.__read(react_1.useState(0), 2), width = _b[0], setWidth = _b[1];
    var buttonRef = react_1.useRef(null);
    react_1.useEffect(function () {
        if (buttonRef === null || buttonRef === void 0 ? void 0 : buttonRef.current) {
            setWidth(buttonRef.current.getBoundingClientRect().width);
        }
    }, []);
    var attributeSelectHandler = react_1.useCallback(function (selectedSortType) {
        var newCurrentItem = buildSortItem(selectedSortType, availableSorts);
        onSelect(newCurrentItem);
    }, [currentSortItem, onSelect, availableSorts]);
    var measureSelectHandler = react_1.useCallback(function (newCurrentItem) {
        onSelect(newCurrentItem);
    }, [currentSortItem, onSelect]);
    var sortTypeItems = getSortTypeItems(availableSorts, bucketItems, intl);
    var selectedSortType = getSelectedItemId(currentSortItem, bucketItems);
    var buttonValue = getButtonValue(sortTypeItems, selectedSortType);
    var renderMeasureDropdown = selectedSortType === types_1.SORT_TARGET_TYPE.NUMERICAL_ASC ||
        selectedSortType === types_1.SORT_TARGET_TYPE.NUMERICAL_DESC;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(Dropdown_1.Dropdown, { closeOnMouseDrag: true, closeOnParentScroll: true, renderButton: function (_a) {
                var isOpen = _a.isOpen, toggleDropdown = _a.toggleDropdown;
                return (react_1.default.createElement("div", { ref: buttonRef },
                    react_1.default.createElement(Dropdown_1.DropdownButton, { className: "s-sort-type-attribute-button-" + index + " s-" + selectedSortType + "-dropdown-button s-attribute-dropdown-button", value: buttonValue, isOpen: isOpen, onClick: toggleDropdown, iconLeft: getIconClassName(selectedSortType) })));
            }, renderBody: function (_a) {
                var closeDropdown = _a.closeDropdown;
                return (react_1.default.createElement(Dropdown_1.DropdownList, { className: "gd-attribute-sorting-dropdown-body s-attribute-sorting-dropdown-body", items: sortTypeItems, width: width, renderItem: function (_a) {
                        var item = _a.item;
                        var id = item.id, title = item.title;
                        var isSelected = id === selectedSortType;
                        var iconClass = getIconClassName(id);
                        var tooltip = id === types_1.SORT_TARGET_TYPE.DEFAULT
                            ? intl.formatMessage({ id: "sorting.default.tooltip" })
                            : undefined;
                        return (react_1.default.createElement(List_1.SingleSelectListItem, { isSelected: isSelected, className: iconClass, title: title, onClick: function () {
                                attributeSelectHandler(item);
                                closeDropdown();
                            }, info: tooltip }));
                    } }));
            } }),
        renderMeasureDropdown ? (react_1.default.createElement(MeasureDropdown_1.MeasureDropdown, { currentItem: currentSortItem, intl: intl, availableSorts: availableSorts, bucketItems: bucketItems, onSelect: measureSelectHandler, disabledExplanationTooltip: availableSorts.explanation, enableRenamingMeasureToMetric: enableRenamingMeasureToMetric, index: index })) : null));
};
//# sourceMappingURL=AttributeDropdown.js.map